window.TipoDocumentoItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-tipo-documento-item",
    tagName: "option",

    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
        this.carregarTiposDocumentoCallback = options.carregarTiposDocumentoCallback;
    },


    onRender: function() {
        this.$el.attr("value", this.model.get("Codigo"));
    }
});


window.TipoDocumentoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-tipo-documento",
    childView: TipoDocumentoItemView,
    childViewContainer: "#lista-tipo-documento",

    events: {
        'change #lista-tipo-documento': "carregarParcelas"
    },

    initialize: function(options) {
        this.app = options.app;
        this.carregarParcelasCallback = options.carregarParcelasCallback;
    },

    carregarParcelas: function(e) {

        if (this.carregarParcelasCallback) {

            this.carregarParcelasCallback($(e.target).val());
        }

    },

    buildChildView: function(item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this,
            carregarParcelasCallback: this.carregarParcelasCallback
        });
        return view;
    },
});